export const getTabPillStateStyles = (
  isActive,
  darkMode,
  {
    darkActiveColor = '#ffffff',
    lightActiveColor = '#ffffff',
    darkInactiveColor = 'rgba(255, 255, 255, 0.6)',
    lightInactiveColor = '#4b5563',
    inactiveDarkBackground = 'transparent',
    inactiveLightBackground = 'rgba(0, 0, 0, 0.05)',
    darkActiveShadow = '0 4px 12px rgba(61, 90, 32, 0.3)',
    lightActiveShadow = '0 6px 16px rgba(61, 90, 32, 0.18)',
  } = {}
) => {
  const activeDarkBackground = '#3d5a20';
  const activeLightBackground = '#1A2811';

  return {
    background: isActive
      ? (darkMode ? activeDarkBackground : activeLightBackground)
      : (darkMode ? inactiveDarkBackground : inactiveLightBackground),
    color: isActive
      ? (darkMode ? darkActiveColor : lightActiveColor)
      : (darkMode ? darkInactiveColor : lightInactiveColor),
    boxShadow: isActive
      ? (darkMode ? darkActiveShadow : lightActiveShadow)
      : 'none',
    border: !darkMode && isActive ? '1px solid rgba(61, 90, 32, 0.35)' : 'none',
  };
};


